import InitComponent from 'Modules/InitComponent';
import store from 'Stores/store';
import CounselorPrompt from 'Main/counselor-prompt/components/CounselorPrompt.vue';

const counselorPrompt = document.querySelectorAll('.counselor-prompt__app');
const initComponent = new InitComponent({
  selectors: counselorPrompt,
  components: { CounselorPrompt },
  template: '<CounselorPrompt />',
  store,
});

initComponent.init();
